import Banner from "../components/Banner";
import Section1 from "./Sections/Section1";
import Section2 from "./Sections/Section2";
import Section3 from "./Sections/Section3";
import Section5 from "./Sections/Section5";
import PageSchema from "../components/PageSchema";

export default function Home() {
  return (
    <>
      <PageSchema
        type="WebPage"
        title="Prime Cloud Systems – IBM, HP, CPU, SSD, HDD Upgrades for Servers, Laptops & Desktops"
        description="Prime Cloud Systems provides high-performance IT hardware, servers, desktops, laptops, and networking equipment. Shop new and certified refurbished products with fast, secure delivery across the USA for home users, IT professionals, and businesses."
        url="https://primecloudsystems.com/"
        image="https://primecloudsystems.com/wp-content/uploads/2024/11/prime-cloud-systems-logo-4500-x-1500.webp"
        breadcrumbs={[{ name: "Home", url: "https://primecloudsystems.com/" }]}
      />

      <Banner />
      <Section1 />
      <Section2 />
      <Section3 />
      <Section5 />
      {/* <Section6 /> */}
    </>
  );
}
